<template>
    <b-modal size="lg" title="Add a Client" hide-footer id="repCreateclientModal">
        <div class="modal-body" style="width: 100%">
            <repCreateClientForm />
            <div class="d-flex justify-content-between mt-2">
                <div></div>
            </div>
        </div>
    </b-modal>
</template>

<script>
import repCreateClientForm from "./repCreateClientForm.vue";
import { clientMethods, clientComputed } from "@/state/helpers";

export default {
    components: { repCreateClientForm },
    data: () => ({}),

    computed: {
        ...clientComputed,
    },
    methods: {
        ...clientMethods,
        // closeModal() {
        //     this.$bvModal.hide("clientModal");
        // },
    },
    mounted() {},
};
</script>

<style lang="scss" scoped></style>
